import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import useResponsive from "@/hooks/useResponsive";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import { featureContainerStyles } from "../styles";

interface IProps {
  path: string;
  title: string;
  url: string;
  thumbnail: string;
  onClick?: () => void;
}

const MenuFeatures: React.FC<IProps> = ({
  path,
  title,
  url,
  thumbnail,
  onClick,
}) => {
  const isMobile = useResponsive("down", "lg");

  return (
    <Link
      to={path}
      style={{ textDecoration: "none" }}
      color="inherit"
      onClick={() => onClick && onClick()}
    >
      <AnimatedImage
        sx={{
          ...featureContainerStyles,
          mb: { xs: 1, lg: 3 },
          img: { width: "100%", height: "auto", objectFit: "contain" },
        }}
        thumbnailUrl={thumbnail}
        mainUrl={url}
        alt={title}
      />
      <Box display="flex" gap={0.5} alignItems="center" color="primary.main">
        <Typography
          variant={isMobile ? "subtitle1" : "h6"}
          color="text.accent"
          fontWeight={700}
          textTransform="capitalize"
        >
          {title}
        </Typography>
        <KeyboardArrowRightIcon color="inherit" fontSize="medium" />
      </Box>
    </Link>
  );
};

export default MenuFeatures;
